module.exports = __webpack_public_path__ + "static/img/newanli-09.6f892443.jpg";